import { GET, omsBaseUrlApi, POST } from '@constants/generic-constants.js';
import NetworkManager from '../../services/network-service.js';
import PermissionsHelper from '../../auth/helper/PermissionHelper.js';
import { ACTION_INDEX, PERMISSION_KEY_REVIEW } from '../../constants/permission-constants.js';
import { ACCESS_DENIED } from '../../constants/seller-center-paths.js';
import { redirectToPath } from '../../utils/utils.js';

export const reviewsListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_REVIEW, ACTION_INDEX)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    let url = `${omsBaseUrlApi}/reviews${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const replyToReviewApi = (id, body) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/reviews/${id}/add_comment`;
    NetworkManager.performRequest(url, body, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getStoreRatingApi = (id) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/stores/${id}/ratings`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getAverageProductRatings = (id) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/stores/${id}/products_ratings`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
